module.exports = __webpack_public_path__ + "img/logo-alfa.42e95d4b.png";